
import { AuthActions } from '@/store/modules/auth/enums';
import { Component, Vue } from 'vue-property-decorator';
import { MediasActions } from '@/store/modules/medias/enums';
import { MerchantConfigActions } from '@/store/modules/merchant-config/enums';
import { Routes } from '@/router/routes';
import { WebPaymentsActions } from '@/store/modules/web-payments/enums';
import CookiesContent from '@/views/cookies/CookiesContent.vue';
import Footer from '@/components/layout/Footer.vue';
import Header from '@/components/layout/Header.vue';
import HeaderBackground from '@/components/layout/HeaderBackground.vue';

@Component({
  components: {
    'ck-cookies-content': CookiesContent,
    'ck-footer': Footer,
    'ck-header': Header,
    'ck-header-background': HeaderBackground,
  },
})
export default class Cookies extends Vue {
  protected show = true;

  account(): void {
    this.$router.push({
      name: Routes.Customer,
      params: { loaded: 'true', showAccount: 'true' },
    });
  }

  async logout(): Promise<void> {
    this.show = false;
    this.$spinner.showSpinner();
    this.$store.dispatch(MerchantConfigActions.Clear);
    this.$store.dispatch(MediasActions.Clear);
    this.$store.dispatch(WebPaymentsActions.Clear);
    this.$store.dispatch(AuthActions.Logout);
    await this.$msal.signOut();
  }
}
